<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'BUYERS.AML_LABEL' | translate }}</h3>
    </div>
  </div>
  <div class="sp-width__full sp-margin__top sp-buyer-details-general-aml__grid sp-grid__column-gap-x2">
    <app-shared-info
      [label]="'BUYERS.AML_ACTIVITY_LABEL'"
      [content]="buyer?.aml?.activity || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.AML_SECTOR_LABEL'"
      [content]="buyer?.aml?.sector || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.AML_OCCUPATION_LABEL'"
      [content]="buyer?.aml?.occupation || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.AML_BUSINESS_PLACE_LABEL'"
      [content]="buyer?.aml?.business_place || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.AML_TAE_LABEL'"
      [content]="buyer?.aml?.tae || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.AML_ACTIVITY_CODE_LABEL'"
      [content]="buyer?.aml?.activity_code || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.AML_SECTOR_CODE_LABEL'"
      [content]="buyer?.aml?.sector_code || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.AML_OCCUPATION_CODE_LABEL'"
      [content]="buyer?.aml?.occupation_code || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
  <div>
    <div class="sp-shared-info__label">{{ 'BUYERS.AML_APICAL_SUBJECT_LABEL' | translate }}</div>
    <mat-radio-group
      class="sp-margin__top sp-margin__bottom-x2 sp-column"
      [value]="buyer?.aml?.is_apical_subject ? 'yes' : 'no'"
      [disabled]="true">
      <mat-radio-button value="yes">
        <span class="sp-color__primary"> {{ 'GENERAL.YES_LABEL' | translate }} </span>
      </mat-radio-button>
      <mat-radio-button value="no">
        <span class="sp-color__primary"> {{ 'GENERAL.NO_LABEL' | translate }} </span>
      </mat-radio-button>
    </mat-radio-group>
  </div>
</div>
